export default __webpack_public_path__ + "img/map-pin-indigo_504a0a3.png";